
import CashierNavBar from "@/components/Cashier/CashierNavBar";
import GoBack from "@/components/GoBack";
import GroupedOrdersModal from "@/components/GroupedOrdersModal";
import TableCart from "@/components/tables/TableCart";
import { useSidebar } from "@/contexts/SidebarContext";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import { invoice, Order, TableData } from "@/types/ApiTypes";

import axios from "axios";

import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {  useParams } from "react-router-dom";



export default function GroupedOrderTable() {
    const { floorId, tableId } = useParams();
    const { t, i18n } = useTranslation();
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [taxesActive, setTaxesActive] = useState(false);
    const [ordersModalOpen, setOrdersModalOpen] = useState(false);
    const [tableOrders, setTableOrders] = useState<Order[]>([]);
    const [refetch, setRefetch] = useState(false);
    const [data, setData] = useState<TableData>();
    const [order, setOrder] = useState<invoice | null>(null);
    const {isShowingIconsOnly} = useSidebar()


    useLockBodyScroll(ordersModalOpen);

    function toggleOrdersModal() {
        setOrdersModalOpen(!ordersModalOpen);
    }
    const [tableData, setTableData] = useState({
        floor: 0,
        table: 0
    });
    async function getTable() {
        setRefetch(false);
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/floors/${floorId}/tables/${tableId}/current-orders?locale=${i18n.language}`,
                method: "GET",
                headers: {
                    Authorization: token,
                },
            }
            const response = await axios.request(options);
            setTableData({
                floor: response.data.table.floor.number,
                table: response.data.table.number
            });
            setTableOrders(response.data.table.orders);
            setData(response.data.table);
        } catch (error) {
            console.error(error);
        }
    }


    useEffect(() => {
        if (!token) return
        getTable();



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, refetch]);

    async function getInvoice() {
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/cashier/grouped-orders/${data?.currentGroupId}/invoice?locale=${i18n.language}`,
                method: "GET",
                headers: {
                    Authorization: token,
                },
            }
            const response = await axios.request(options);
            setOrder(response.data.invoice);
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        if (data?.currentGroupId) {
            getInvoice();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data?.currentGroupId, refetch]);

    return (
        <>

            {ordersModalOpen && <GroupedOrdersModal order={order!} setRefetch={setRefetch} tableData={tableData} toggleOrdersModal={toggleOrdersModal} orders={tableOrders} />}
            <div className="space-y-2">
             <GoBack />
                <h1 className="text-2xl text-center bg-skyblue py-2 rounded-lg text-sidebar"> {t("manageTables.floor")} {tableData.floor} - {t("manageTables.table")} {tableData.table}</h1>
                <div className="flex items-center justify-end">

                    <div>
                        <button onClick={toggleOrdersModal} className="my-btn px-2">
                            {t("manageTables.TableOrders")}
                        </button>
                    </div>
                </div>



                <div className={`grid grid-cols-4 gap-4 ${isShowingIconsOnly ? "lg:grid-cols-[repeat(18,minmax(0,1fr))]" : "lg:grid-cols-[repeat(14,minmax(0,1fr))]"} break2lg-grid-cols-18 2xl:grid-cols-12 `}>
                    <CashierNavBar setTaxesActive={setTaxesActive} isTables={true} />
                    {tableId && floorId && data && <TableCart tableData={tableData} taxActivated={taxesActive} tableId={tableId} floorId={floorId} setRefetch={setRefetch} total={data?.grandTotal || 0} data={data} />  }
                </div>

            </div>
        </>
    )
}
